
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Bind, Debounce } from 'lodash-decorators'
import BookManager, { EumLoadStatus, EnumScrollDirection } from '@xt/client/utils/book'
import { Observer } from 'mobx-vue'
import { reportEntryLog } from '@xt/client/utils/log'
import { getServerTime } from '@xt/client/experimental/server-time'
import lodash from 'lodash'
import { Chapter } from '@xt/client/types/book'

type Menu = {
  key: string
  name: string
  subchapter: Chapter[]
}

@Observer
@Component({
  components: {}
})
export default class ChapterTOC extends Vue {
  @Prop({ required: true }) currentBook!: string
  // 避免目录关闭状态下，切换章节失效
  @Prop({ required: true }) currentKeys!: string
  // 所有根目录数据
  @Prop({ required: true }) rootSubmenuKeys!: string[]
  @Prop({ required: true }) bookName!: string
  @Prop({ required: true }) downloadURL!: string
  @Prop({ required: true }) chapter!: Array<Chapter>

  rob: ResizeObserver | null = null
  hasMaxHeight: boolean = false
  menuScrollMax: number = 0
  openKeys: string[] = []
  // 避免目录关闭情况下点击自身切换images资源
  currentImagListKeys: string = ''

  get menuScrollStyle() {
    return this.hasMaxHeight ? { maxHeight: `${this.menuScrollMax}px` } : {}
  }

  // 上一章
  handlePrev() {
    let index = this.rootSubmenuKeys.findIndex(i => i == this.currentKeys)

    if (index == -1 || index == 0) return

    this.openKeys = [this.rootSubmenuKeys[--index]]

    this.onOpenChange(this.openKeys)
  }

  // 下一章
  handleNext() {
    let index = lodash.values(this.rootSubmenuKeys).findIndex(i => i == this.currentKeys)

    if (index == -1 || index == this.rootSubmenuKeys.length - 1) return

    this.openKeys = [this.rootSubmenuKeys[++index]]

    this.onOpenChange(this.openKeys)
  }

  @Emit('click-menu')
  handleClickMenu(key: string) {
    return key
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  async onDownload() {
    try {
      const url = await BookManager.getDownloadUrl(this.currentBook, this.downloadURL)
      this.onOpenBlock(url, encodeURIComponent(this.bookName))
    } catch (error) {
      if (error instanceof Error) {
        this.$msg(error.message)
      }
      reportEntryLog('debug.book-download.error', {
        now: getServerTime('timestamp'),
        bookId: this.currentBook,
        error: error.message || error.errMsg || error
      })
    }
  }

  onOpenChange(openKeys) {
    // 保持每次只展开一个菜单项
    const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)

    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.openKeys = openKeys
    } else {
      this.openKeys = latestOpenKey ? [latestOpenKey] : []
    }

    // 点击目录处于展开状态且不等于上一次打开的目录时更新ImageList数据
    if (this.openKeys.length === 0 || this.openKeys[0] === this.currentImagListKeys) return

    this.$emit('update-current-keys', this.openKeys[0])

    this.currentImagListKeys = this.openKeys[0]

    // 点击根节点跳转封面
    document.documentElement.scrollTo({ top: 0 })

    // 切换目录的时候也要刷新一下
    this.updateMenuScrollMax()

    // 切换目录时清除图片缓存
    BookManager.cleanData()
  }

  // 根据屏幕高度判断菜单放不放的下
  @Debounce(300)
  @Bind()
  updateMenuScrollMax() {
    // 保证每次获取到展开的目录高度
    this.hasMaxHeight = false

    this.$nextTick(() => {
      const el: HTMLElement | null = document.querySelector('#book-menu-target')
      if (el) {
        // 长度超出视口高度时
        if (Math.floor(el.offsetHeight) > window.innerHeight - 66) {
          this.hasMaxHeight = true
        }
        // 操作了目录的高度
        this.menuScrollMax = window.innerHeight - 210
      }
    })
  }

  setWindowOberver() {
    const el = document.body
    if (el) {
      if (this.rob) {
        this.rob.disconnect()
        this.rob = null
      }

      this.rob = new ResizeObserver(this.updateMenuScrollMax)
      this.rob.observe(el)
    }
  }

  created(): void {}

  mounted(): void {
    // 打开对应的目录
    this.openKeys = [this.chapter[0].key]
    // 兼容大屏完整展示目录，小屏不用折叠滚动目录的场景
    this.updateMenuScrollMax()
    this.setWindowOberver()
  }

  updated(): void {}

  destroyed(): void {
    if (this.rob) {
      this.rob.disconnect()
      this.rob = null
    }
  }
}
